var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./EventsList.jinja');
require('./EventsList.less');

var CommonEventsList = require('front/components/CommonEventsList/CommonEventsList');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonEventsList': {selector: '.CommonEventsList', viewConstructor: CommonEventsList}
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/EventsList/EventsList.js
// module id = 176
// module chunks = 0